<!--  WELCOME  -->

<div class="written-content padded welcome-modal">
	<h3
		[attr.data-element-view]="
			'heading__engage_configure_welcome_modal__[Customise your deal in ' + steps.length + ' easy steps!]'
		"
	>
		Customise your deal in
		<span [attr.data-element-view]="'step_count__engage_configure_welcome_modal__[' + steps.length + ']'">
			{{ steps.length }}
		</span>
		easy steps!
	</h3>
	<p>
		This easy service puts you in control so you can go at your own pace, under no pressure and tailor your own
		deal.
	</p>

	<!--  STEPS  -->

	<ul class="bullet-ol">
		<!--  STEP LOOP  -->

		<li *ngFor="let message of trust_messages" [attr.data-element-view]="message.gtm_label || null">
			<span class="bullet sec-fg sec-bg">
				<i class="icon-tick"></i>
			</span>
			<span class="text">{{ message.text }}</span>
		</li>

		<!--  END STEP LOOP  -->
	</ul>

	<!--  END STEPS  -->

	<cng-progress-bar-static [location]="'engage_configure_welcome_modal'"></cng-progress-bar-static>

	<p>Your progress will be automatically saved and you can contact us at any point with further questions.</p>

	<p><strong class="col-dark-grey">Ready to begin?</strong></p>
	<ui-trust-logos [location]="'engage_configure_welcome_modal'"></ui-trust-logos>
</div>

<!--  END WELCOME  -->
